import { QuestionCircleOutlined } from '@ant-design/icons'
import { Space, Switch, Tooltip } from 'antd'

import { SimpleModeSwitchProps } from './interface'

export const SimpleModeSwitch = ({
  value,
  onChange
}: SimpleModeSwitchProps) => {
  return (
    <Space>
      <span>
        精简模式&nbsp;
        <Tooltip title='只展示常用的小时与分钟选项'>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <Switch checked={value} onChange={onChange} />
    </Space>
  )
}
